import { i as o } from "./index-E8vB_04G.js";
import { l as a } from "./index-b-LDu0Rp.js";
var u = /* @__PURE__ */ ((i) => (i[i.RSA = 0] = "RSA", i))(u || {});
class h {
  certChain;
  keypair;
  userId;
  _endorsements = o.EnclaveEndorsements.create({});
  /**
   * Create an authentication object with the supplied certificate chain and keypair.
   * To use the identity provider of the decentriq platform use
   * [[`Client.platform.createAuthUsingDecentriqPki`]].
   */
  constructor(t, e, n) {
    this.certChain = t, this.keypair = e, this.userId = n;
  }
  /**
   * Returns the chain of certificates in PEM format.
   */
  getCertificateChainPem() {
    return this.certChain;
  }
  getUserId() {
    return this.userId;
  }
  sign(t) {
    const e = a.md.sha512.create();
    e.update(a.util.binary.raw.encode(t));
    const n = this.keypair.privateKey.sign(e);
    return a.util.binary.raw.decode(n);
  }
  attachEndorsement({
    decentriqPki: t,
    personalPki: e,
    dcrSecret: n
  }) {
    t && (this._endorsements.dqPki = t), e && (this._endorsements.personalPki = e), n && (this._endorsements.dcrSecret = n);
  }
  detachEndorsement(t) {
    switch (t) {
      case "decentriqPki":
        this._endorsements.dqPki = void 0;
        break;
      case "personalPki":
        this._endorsements.personalPki = void 0;
        break;
      case "dcrSecret":
        this._endorsements.dcrSecret = void 0;
        break;
    }
  }
  get endorsements() {
    return this._endorsements;
  }
}
class g {
  signature;
  macTag;
  authPki;
  constructor(t, e, n) {
    this.signature = t, this.macTag = e, this.authPki = n;
  }
  getSignature() {
    return this.signature;
  }
  getMacTag() {
    return this.macTag;
  }
  getCertChain() {
    return this.authPki.getCertificateChainPem();
  }
}
async function l(i = 0, t = 4096) {
  switch (i) {
    case 0:
      return await new Promise((n, r) => {
        a.pki.rsa.generateKeyPair({ bits: t }, (s, c) => {
          s && r(s), n(c);
        });
      });
  }
}
function f(i, t) {
  const e = a.pki.createCertificate();
  e.setSubject([
    {
      name: "commonName",
      value: i
    }
  ]), e.setIssuer([
    {
      name: "commonName",
      value: i
    }
  ]), e.serialNumber = "01";
  const n = /* @__PURE__ */ new Date(), r = new Date(n);
  r.setDate(r.getDate() - 1), e.validity.notBefore = r;
  const s = new Date(n);
  return s.setDate(s.getDate() + 10), e.validity.notAfter = s, e.setExtensions([
    {
      cA: !1,
      name: "basicConstraints"
    },
    {
      dataEncipherment: !1,
      digitalSignature: !0,
      keyCertSign: !1,
      keyEncipherment: !0,
      name: "keyUsage",
      nonRepudiation: !0
    }
  ]), e.publicKey = t.publicKey, e.sign(t.privateKey, a.md.sha512.create()), a.pki.certificateToPem(e);
}
function p(i, t) {
  const e = a.pki.createCertificationRequest();
  return e.setSubject([
    {
      name: "commonName",
      value: i,
      valueTagClass: a.asn1.Type.UTF8
    }
  ]), e.setAttributes([
    {
      extensions: [
        {
          cA: !1,
          name: "basicConstraints"
        },
        {
          dataEncipherment: !1,
          digitalSignature: !0,
          keyCertSign: !1,
          keyEncipherment: !0,
          name: "keyUsage",
          nonRepudiation: !0
        }
      ],
      name: "extensionRequest"
    }
  ]), e.publicKey = t.publicKey, e.sign(t.privateKey, a.md.sha512.create()), a.pki.certificationRequestToPem(e);
}
export {
  h as Auth,
  u as KeyType,
  g as Sigma,
  p as generateCsrPem,
  l as generateKey,
  f as generateSelfSignedCertificate
};
//# sourceMappingURL=authentication.js.map
